import React from 'react';
import './Navbar.css';

const Navbar: React.FC = () => {
  return (
    <nav>ポケモン図鑑</nav>
  );
};

export default Navbar;
